export default "__VITE_ASSET__Cd4GzRqA__"